import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

import EditIcon from "@mui/icons-material/Edit";
import dummyPic from "../../../assets/Images/avtarPic.png";
// import UploadIcon from "@mui/icons-material/Upload";

//Validations For Society Details
const Validation_Schema = Yup.object().shape({
  societyName: Yup.string()
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers not allowed!!"
    ),
  contact: Yup.string().matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits")
    .max(10, "phone no must be 10 digits")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  // google_map_image:Yup
  // .mixed()
  // .required("Required")
    XAxis:Yup.string().required("Required"),
  YAxis:Yup.string().required("Required"),
   
});

function AddSocietyNew() {
  const navigate = useNavigate();

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  const [profile_pic, setProfilePic] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [email, setemail] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [societyName, setSocietyName] = React.useState("");
  const [building_count, setBuilding_count] = React.useState(0);
  const [showLoader, setShowLoader] = React.useState(false);
  const [, setGoogleMapImage] = React.useState("");
  const [XAxis, setXAxis] = React.useState("");
  const [YAxis, setYAxis] = React.useState("");

  var formikInitials = {
    societyName: "",
    contact: "",
    email: "",
    address: "",
    building_count: 0,
    // google_map_image:undefined
    XAxis:0,
    YAxis:0
  };

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;
    setShowLoader(true);
    await uploadFileRequest("guards/uploadImages", formData)
      .then((response) => {
        fileUrl = response.data.imagepath[0].location;
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadProfilePic(e,type) {
    setShowLoader(true);
    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      if(type==='GoogleMap')
        setGoogleMapImage(profilePicUrl)
      else if(type==='societyImage')
        setProfilePic(profilePicUrl);
    } else swal("Please upload a file with image format only", "", "warning");
    setShowLoader(false);
  }

  async function addSociety() {
    // alert("DOne")
    // alert(" Map Name ", google_map_image)
    let isGetByName = "";
    await makeGetRequest("society/getbyname/" + societyName).then(
      (response) => {
        console.log(response);

        if (response.data.data) {
          isGetByName = true;
        } else isGetByName = false;
      }
    );
    if (isGetByName)
      swal("Already Exist!", "Society With Same Name Already Exist", "warning");
    else {
      let inputdata = {
        society_name: societyName,
        society_image: profile_pic,
        contact: contact,
        email_id: email,
        address: address,
        building_count: building_count,
        xaxis_in_meter: XAxis,
        yaxis_in_meter: YAxis,
        ref_latitude: 0,
        ref_longitude: 0,
        // document_list:[],
        // google_map_image:google_map_image
      };

      setShowLoader(true);
      await makePostRequest("society/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal(
              "Society Added Successfully",
              "Please Assign Rights to Society",
              "success",
              {
                timer: 1000,
                buttons: false,
              }
            );
            navigate("/AssignRights");

            setShowLoader(false);
            window.location.reload();
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          setShowLoader(false);
        });
    }
  }

  async function GetSocietyByName(societyName) {
    await makeGetRequest("society/getbyname/" + societyName).then(
      (response) => {
        console.log(response);

        if (response.data.data) {
          return true;
        } else return false;
      }
    );
  }

  return (
    <>
      <div id="successfullAdd">
        <Formik
          enableReinitialize
          initialValues={formikInitials}
          validationSchema={Validation_Schema}
          onSubmit={addSociety}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => (
            <Form>
              <Grid container spacing={3} className="addCommitee1">
                <Grid item xs={12} md={12}>
                  <div
                    className="uploadImDiv uploadImDivNew"
                    style={{ marginTop: 15 }}
                  >
                    <div className="uploadInpuNewUpIm">
                      <div className="uploadIm">
                       
                       {profile_pic?
                          <img src={profile_pic} />
                        :
                        <img src={dummyPic} />
                       }

                      </div>
                      <div className="uploadInpu">
                        <EditIcon />
                        <input
                          type="file"
                          id="profile_pic"
                          value={values.profile_pic}
                          onChange={(event) => uploadProfilePic(event,'societyImage')}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Society Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    value={values.societyName}
                    onChange={handleChange("societyName")}
                    onBlur={(e) => setFieldTouched("societyName")}
                    onChangeCapture={(e) => setSocietyName(e.target.value)}
                  />
                  {errors.societyName && touched.societyName ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.societyName}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    id="contact"
                    value={values.contact}
                    maxLength={10}
                    onChange={handleChange("contact")}
                    onBlur={(e) => setFieldTouched("contact")}
                    onChangeCapture={(e) => setcontact(e.target.value)}
                  />
                  {errors.contact && touched.contact ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.contact}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Email Id <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    id="email"
                    value={values.email}
                    onChange={handleChange("email")}
                    onBlur={(e) => setFieldTouched("email")}
                    onChangeCapture={(e) => setemail(e.target.value)}
                  />
                  {errors.email && touched.email ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.email}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    id="address"
                    value={values.address}
                    onChange={handleChange("address")}
                    onBlur={(e) => setFieldTouched("address")}
                   
                    onChangeCapture={(e) => setAddress(e.target.value)}
                  />
                  {errors.address && touched.address ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.address}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">Building Count</label>
                  <input
                    className="modalInputStSelect"
                    id="buildingCount"
                    value={values.building_count}
                    onChange={handleChange("building_count")}
                    onBlur={(e) => setFieldTouched("building_count")}
                   
                    onChangeCapture={(e) => setBuilding_count(e.target.value)}
                  />
                  {errors.building_count && touched.building_count ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.building_count}
                    </div>
                  ) : null}
                </Grid>
                {/* <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Google Map <span style={{ color: "red" }}>*</span></label>
                              <div className="uploadImgOut inputSt upLoadStInpt">
                                <span className="imgName">
                                  {google_map_image
                                    .split("/")
                                    .pop()
                                    .replace("%20", " ")}{" "}
                                </span>
                                <input
                                  type="file"
                                  placeholder="Google Map"
                                  value={values.google_map_image}
                                  onChange={handleChange}
                                  // onChange={(event) => uploadProfilePic(event,'GoogleMap')}
                                />
                                <UploadIcon />
                                {errors.google_map_image &&
                                touched.google_map_image ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.google_map_image}
                                  </div>
                                ) : null}
                              </div>
                            </Grid> */}
                <Grid item xs={12} md={6}>
                        <label className="tabsLabel">X-Axis in Meter  <span style={{ color: "red" }}>*</span></label>
                        <input
                          className="inputSt"
                          placeholder="10"
                          value={values.XAxis}
                          onChange={handleChange("XAxis")}
                          onBlur={() => setFieldTouched("XAxis")}
                          onChangeCapture={(e) => setXAxis(e.target.value)}
                        />
                        {errors.XAxis && touched.XAxis ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.XAxis}
                          </div>
                        ) : null}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Y-Axis in Meter <span style={{ color: "red" }}>*</span></label>
                        <input
                          className="inputSt"
                          placeholder="30"
                          value={values.YAxis}
                          onChange={handleChange("YAxis")}
                          onBlur={() => setFieldTouched("YAxis")}
                          onChangeCapture={(e) => setYAxis(e.target.value)}
                        />
                        {errors.YAxis && touched.YAxis ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.YAxis}
                          </div>
                        ) : null}
                      </Grid>


                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button type="submit" className="modalMainBt">
                      Add Society
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Society added <br />
                successfully in database
              </p>
            </div>
          </Grid>
        </Grid>
        {showLoader ? (
          <div className="loaderOter" id="loaderId">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <span>Loading</span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
export default AddSocietyNew;
